import { Component, input } from '@angular/core';

@Component({
  selector: 'tooltip',
  imports: [],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss'
})
export class TooltipComponent {
  floatPosition = input<FloatPositions>('top-center')
  size = input<number>(18);
}

type FloatPositions =
'top-start'
|'top-center'
|'top-end'
|'right-top'
|'right-center'
|'right-bottom'
|'left-top'
|'left-center'
|'left-bottom'
|'bottom-start'
|'bottom-center'
|'bottom-end'
